import { defineStore } from 'pinia'

export const useAuthPanelStore = defineStore({
    id: 'authPanel',

    state () {
        return {
            state: 'login',
            direction: 'left'
        }
    }
})
